// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__Hy6bb","fileBtn":"File_fileBtn__1yF_v","closeBtn":"File_closeBtn__1j1El","fileSelected":"File_fileSelected__3PZol","disabled":"File_disabled__1GSs_"};